<script>
export default {
  name: 'BlockList',
  components: {},
  props: {},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="block-list">
    <slot name="default"></slot>
  </div>
</template>

<style lang="scss" scoped>
.block-list {
  width: 100%;
}
</style>